export function LoadingPage() {
	return (
		<h1 className="title is-1 has-text-centered">
			<div className="is-inline-block is-loading" data-testid="loading"></div>
			&nbsp; Loading...
		</h1>
	);
}
